import type { EditorSelectFormValues } from "./schema-builder-field-editor-select.type";
import type { GetEditorValuesOptions } from "../schema-builder-field-editor.type";
import type { SchemaFieldSelect } from "@/entities/schema";

import isEqual from "lodash/isEqual";

import { isSchemaFieldSelect } from "@/entities/schema";

import {
  getSchemaSelectValuesFromValues,
  getSelectValuesFromSchema,
} from "../../schema-builder-select";
import {
  getEditorDefaultValues,
  getNewSchemaFieldOptionsFromValues,
  isEditorDefaultFormValuesEqual,
} from "../schema-builder-field-editor-default";

export const getEditorSelectValues = (
  options: GetEditorValuesOptions
): EditorSelectFormValues => {
  const { schema } = options;

  const formValues: EditorSelectFormValues = {
    fieldType: "select",
    values: [],
    ...getEditorDefaultValues(options),
  };

  if (!isSchemaFieldSelect(schema)) return formValues;

  return {
    ...formValues,
    values: getSelectValuesFromSchema(schema),
  };
};

export const isEditorSelectFormValuesEqual = (
  a: EditorSelectFormValues,
  b: EditorSelectFormValues
) => {
  if (!isEditorDefaultFormValuesEqual(a, b)) return false;
  if (!isEqual(a.values, b.values)) return false;
  return true;
};

export const getNewSchemaSelectFromValues = (
  formValues: EditorSelectFormValues
): SchemaFieldSelect => {
  return {
    type: "select",
    ...getNewSchemaFieldOptionsFromValues(formValues),
    values: getSchemaSelectValuesFromValues(formValues.values),
  };
};
